(function($, Drupal, drupalSettings) {

  var cutoffCalculatorFirstLoad = true;

  Drupal.behaviors.cutoff_calculator = {
    attach: function (context, settings) {

      if (cutoffCalculatorFirstLoad && $('.webform-submission-cut-off-calculator-form').length) {
        cutoffCalculatorFirstLoad = false;
      } else {
        return false;
      }

      var jsonData = {};
      $.getJSON(Drupal.url().replace('/undefined', '') + "/modules/custom/cutoff_calculator/js/data/sgbm.json", function( myData) {
          processCurrencyJSON(myData);
      });
      $.getJSON(Drupal.url().replace('/undefined', '') + "/modules/custom/cutoff_calculator/js/data/sccb.json", function( myData) {
          processCurrencyJSON(myData);
      });
      $.getJSON(Drupal.url().replace('/undefined', '') + "/modules/custom/cutoff_calculator/js/data/ccy-pairs.json", function( myData) {
          processPairsJSON(myData);
      });

      $("select[name='account_currency']").change(function() {
          changeOutput();
      });
      $("select[name='payment_currency']").change(function() {
          changeOutput();
      });

      function changeOutput() {
          var acc_curr = $("select[name='account_currency']").val();
          var pay_curr = $("select[name='payment_currency']").val();
          var textCutoff = "";
          var textValue = "";

          if (acc_curr != 'Please select' && pay_curr != 'Please select') {
              // check if setup
              // look for a matching pair of currency values
              var location = jsonData.pairData.CCY_pair.indexOf(acc_curr + "/" + pay_curr);
              if (location != -1) {
                  isSetup = jsonData.pairData.setup[location];
              } else {
                  isSetup = "No";
              }

              // set 'Available' to either Yes or No
              $(".col-three").text(isSetup);
              if (isSetup === 'No' || isSetup === ' No') {
                  $(".col-four").text("-");
                  $(".col-five").text("-");
              } else {
                  var sccbLocation = jsonData.sccbData.SCCB.indexOf(acc_curr);
                  if (acc_curr == pay_curr) {
                      // if both the same - set to values in myData.SCCB
                      if (sccbLocation != -1) {
                          textCutoff = jsonData.sccbData.Cut_off[sccbLocation];
                          textValue = jsonData.sccbData.ValueDate[sccbLocation];
                      }
                  } else {
                      var sgbmLocation = -1;
                      var currencies = ["MXN", "ILS", "HUF", "CZK", "MAD", "INR", "AED", "PHP", "AUD", "JPY", "NZD", "HKD", "ZAR", "SGD", "THB", "NOK", "DKK", "PLN", "CHF","CNH","TRY","RON","QAR","SAR","SEK", "EUR", "CAD", "USD", "GBP"];
                      for (var i=0; i < currencies.length; i++) {
                         if (acc_curr == currencies[i] || pay_curr == currencies[i]) {
                              sgbmLocation = jsonData.sgbmData.SGBM.indexOf(currencies[i]);
                              break;
                          }
                      }

                      // deals with default value from spreadsheet excel macro
                      if (sgbmLocation < 0) sgbmLocation = jsonData.sgbmData.SGBM.indexOf("USD");

                      textCutoff = jsonData.sgbmData.Cut_off[sgbmLocation];
                      textValue = jsonData.sgbmData.ValueDate[sgbmLocation];

                      //MXN rewrite -- Due to mexico being to complicated for this setup these rewrites are used to assign many of mexicos results

                      if(acc_curr === 'CHF' && pay_curr === 'MXN' ||
                         acc_curr === 'MXN' && pay_curr === 'CHF') {
                          textCutoff = '11:30';
                          textValue = 'Same Day';
                      }

                      if(acc_curr === 'EUR' && pay_curr === 'MXN' ||
                         acc_curr === 'MXN' && pay_curr === 'EUR') {
                          textCutoff = '14:00';
                          textValue = 'Same Day';
                      }

                      if(acc_curr === 'GBP' && pay_curr === 'MXN' ||
                         acc_curr === 'MXN' && pay_curr === 'GBP') {
                          textCutoff = '14:00';
                          textValue = 'Same Day';
                      }

                      if(acc_curr === 'USD' && pay_curr === 'MXN' ||
                         acc_curr === 'MXN' && pay_curr === 'USD') {
                          textCutoff = '14:00';
                          textValue = 'Same Day';
                      }

                      if(acc_curr === 'MXN' && pay_curr === 'MXN') {
                          textCutoff = '14:00';
                          textValue = 'Same Day';
                      }

                      //CHF rewrite
                      if(acc_curr === 'CHF' && pay_curr === 'CAD' ||
                         acc_curr === 'CAD' && pay_curr === 'CHF' ||
                         acc_curr === 'CHF' && pay_curr === 'EUR' ||
                         acc_curr === 'EUR' && pay_curr === 'CHF' ||
                         acc_curr === 'CHF' && pay_curr === 'GBP' ||
                         acc_curr === 'GBP' && pay_curr === 'CHF' ||
                         acc_curr === 'SEK' && pay_curr === 'CHF' ||
                         acc_curr === 'CHF' && pay_curr === 'SEK' ||
                         acc_curr === 'USD' && pay_curr === 'CHF' ||
                         acc_curr === 'CHF' && pay_curr === 'USD') {
                          textCutoff = '11:30';
                          textValue = 'Same Day';
                      }

                      //CNH rewrite
                      if(acc_curr === 'CNH' && pay_curr === 'CNH' ||
                         acc_curr === 'CNH' && pay_curr === 'GBP' ||
                         acc_curr === 'GBP' && pay_curr === 'CNH' ||
                         acc_curr === 'EUR' && pay_curr === 'CNH' ||
                         acc_curr === 'CNH' && pay_curr === 'EUR' ||
                         acc_curr === 'CNH' && pay_curr === 'USD' ||
                         acc_curr === 'USD' && pay_curr === 'CNH') {
                          textCutoff = '14:00';
                          textValue = 'Next working day';
                      }

                      //TRY rewrite
                      if(acc_curr === 'TRY' && pay_curr === 'TRY' ||
                         acc_curr === 'TRY' && pay_curr === 'GBP' ||
                         acc_curr === 'GBP' && pay_curr === 'TRY' ||
                         acc_curr === 'EUR' && pay_curr === 'TRY' ||
                         acc_curr === 'TRY' && pay_curr === 'EUR' ||
                         acc_curr === 'TRY' && pay_curr === 'USD' ||
                         acc_curr === 'USD' && pay_curr === 'TRY') {
                          textCutoff = '14:00';
                          textValue = 'Next working day';
                      }

                      //QAR rewrite
                      if(acc_curr === 'QAR' && pay_curr === 'QAR' ||
                         acc_curr === 'QAR' && pay_curr === 'GBP' ||
                         acc_curr === 'GBP' && pay_curr === 'QAR' ||
                         acc_curr === 'EUR' && pay_curr === 'QAR' ||
                         acc_curr === 'QAR' && pay_curr === 'EUR' ||
                         acc_curr === 'QAR' && pay_curr === 'USD' ||
                         acc_curr === 'USD' && pay_curr === 'QAR') {
                          textCutoff = '17:00';
                          textValue = '2 working days';
                      }

                      //RON rewrite
                      if(acc_curr === 'RON' && pay_curr === 'RON' ||
                         acc_curr === 'RON' && pay_curr === 'GBP' ||
                         acc_curr === 'GBP' && pay_curr === 'RON' ||
                         acc_curr === 'EUR' && pay_curr === 'RON' ||
                         acc_curr === 'RON' && pay_curr === 'EUR' ||
                         acc_curr === 'RON' && pay_curr === 'USD' ||
                         acc_curr === 'USD' && pay_curr === 'RON') {
                          textCutoff = '14:00';
                          textValue = 'Next working day';
                      }

                      //SAR rewrite
                      if(acc_curr === 'SAR' && pay_curr === 'SAR' ||
                         acc_curr === 'SAR' && pay_curr === 'GBP' ||
                         acc_curr === 'GBP' && pay_curr === 'SAR' ||
                         acc_curr === 'EUR' && pay_curr === 'SAR' ||
                         acc_curr === 'SAR' && pay_curr === 'EUR' ||
                         acc_curr === 'SAR' && pay_curr === 'USD' ||
                         acc_curr === 'USD' && pay_curr === 'SAR') {
                          textCutoff = '17:00';
                          textValue = '2 working days';
                      }

                      //EUR-EUR overwrite
                      if(acc_curr === 'EUR' && pay_curr === 'EUR') {
                          textCutoff = '14:50';
                          textValue = 'Same Day';
                      }
                      //JPY-CZK overwrite
                      if(acc_curr === 'JPY' && pay_curr === 'CZK') {
                          textCutoff = '14:30';
                          textValue = 'Next working day';
                      }
                  }
                  $(".col-four").text(textCutoff);
                  $(".col-five").text(textValue);
              }

          } else {
            $(".col-three").html('&nbsp;');
            $(".col-four").html('&nbsp;');
            $(".col-five").html('&nbsp;');
          }

      }

      function processCurrencyJSON(myData) {
          if (myData.SGBM) {
              for (val in myData.SGBM) {
                  var entry = myData.SGBM[val];
                  if (entry.length == 3) {    //to remove strange bug where in IE8 last entry is a function
                      $("select[name='account_currency']")
                          .append($("<option></option>")
                              .attr("value", entry)
                              .text(entry));
                  }

              };
              jsonData.sgbmData = myData;
          };


          if (myData.SCCB) {
              for (val in myData.SCCB) {
                  var entry = myData.SCCB[val];
                  if (entry.length == 3) {    //to remove strange bug where in IE8 last entry is a function
                      $("select[name='payment_currency']")
                          .append($("<option></option>")
                              .attr("value", entry)
                              .text(entry));
                  }
              };
              jsonData.sccbData = myData;
          };
      }

      function processPairsJSON(myData) {
          jsonData.pairData = myData;
      }

      // Show select search.
      $('#edit-account-currency,#edit-payment-currency').on('select2:open', function () {
        $('.select2-container .select2-search.select2-search--dropdown').css('display', 'block');
      });
      $('#edit-account-currency,#edit-payment-currency').on('select2:close', function () {
        $('.select2-container .select2-search.select2-search--dropdown').hide();
      });

    }
  }; // Drupal.behaviors.cutoff_calculator

})(jQuery, Drupal, drupalSettings);
